import { Box, Typography } from '@mui/material';

export const CharterersPage = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Charterers Management
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Charterers management interface will be implemented here. This will include viewing,
        creating, editing, and managing charterer data.
      </Typography>
    </Box>
  );
};
